import { ArrowDownward } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import { useQueryParams } from "../../../../hooks/useQueryParams";

export default function ShowMoreButton({
  showMoreVisible,
  showMoreAmt,
  CustomIcon,
  queryKey = "",
}) {
  const { filters, updateFilter } = useQueryParams();

  function handleShowMore() {
    const oldLimit = filters.get(queryKey) || 20;
    const newLimit = Number(oldLimit) + showMoreAmt;
    updateFilter(queryKey, newLimit);
  }

  if (!showMoreVisible) {
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Tooltip title="Show more results">
        <IconButton size="small" onClick={handleShowMore}>
          {CustomIcon ? CustomIcon : <ArrowDownward />}
        </IconButton>
      </Tooltip>
    </div>
  );
}
